// extracted by mini-css-extract-plugin
export default {"aboutIntroSection":"aboutUs_aboutIntroSection__eVrfs","timelineSection":"aboutUs_timelineSection__h7Ic2","headerSection":"aboutUs_headerSection__0Pm-1"};